import { OrderItemProps } from './types';

export const OrderItem = ({ lineItems }: OrderItemProps) => (
  <>
    {lineItems.map(({ title, quantity }) => (
      <p className="d-flex" key={title}>
        <span className="mr-3">{quantity}&times;</span>
        <span>{title}</span>
      </p>
    ))}
  </>
);
